import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const SupplierCategoryRuleRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--supplier-category-rule']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
